<template>
  <div class="py-4 container-fluid">
    <div v-if="!isLoading" class="row">
      <div class="col-12">
        <navbaroptions
          isBlur="blur border-radius-lg py-2 start-0 end-0 mb-3 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
          toRoute="/gallery-card/0"
        />
      </div>
      <div class="col-12">
        <argon-alert v-if="showAlert" color="danger" :dismissible="true" @close-alert="closeAlert">
          <strong>Gallery!</strong> Eliminado correctamente!
        </argon-alert>
      </div>
      <div
        class="col-lg-6 col-md-6 col-12 mb-4"
        v-for="gallery in galleries"
        :key="gallery.id"
      >
        <!-- <router-link :to="`/Bypass`"> -->
        <galleries-table :gallery="gallery" />
        <!-- </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import GalleriesTable from "./components/GalleriesTable.vue";
import Navbaroptions from "@/examples/PageLayout/Navbaroptions.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "gallery",
  components: { GalleriesTable, Navbaroptions, ArgonAlert },
  data() {
    return {
      galleries: undefined,
      isLoading: true,
      showAlert: false,
    };
  },
  created() {
    this.plain
      .get(`/galleries`)
      .then((response) => {
        // console.log('GALLERIES TOTALES');
        // console.log(response.data);
        if (response.data.length !== 0) this.galleries = response.data;
        else this.galleries = [];
        this.isLoading = false;
      })
      .catch((err) => {
        this.galleries = [];
        this.isLoading = false;
        console.log(err);
      });
  },
  methods: {
    deleteItemGallery(galleryID) {
      this.showAlert = true
      this.galleries = this.galleries.filter(({ id }) => id !== galleryID);
      // console.log("GALLERIES GALLERIES GALLERY");
      // console.log(this.galleries);
      window.scrollTo(0, 0);
    },
    closeAlert(){
      this.showAlert = false;
    }
  },
};
</script>
